import React from 'react';
import { Redirect } from 'react-router-dom';
import DashboardPage from 'pages/Dashboard/DashboardPage';
import FinancialDashboardPage from 'pages/FinancialDashboard/FinancialDashboardPage';
import OperationalDashboardPage from 'pages/OperationalDashboard/OperationalDashboardPage';

const NewsFeedRedirect = () => <Redirect to='/news-inside' />;

const dashboardRoute = [
  {
    path: '/',
    exact: true,
    name: 'Bảng tin nội bộ',
    allowLoggedIn: true,
    component: NewsFeedRedirect,
  },
  {
    path: '/dashboard',
    exact: true,
    name: 'Tổng quan',
    function: ['MENU_DASHBOARD', 'DASHBOARD_VIEW'],
    any: true,
    component: DashboardPage,
  },
  {
    path: '/dashboard/financial-overview',
    exact: true,
    name: 'Tổng quan tài chính',
    function: 'DASHBOARD_FINANCIAL_OVERVIEW_VIEW',
    component: () => <FinancialDashboardPage mode='overview' />,
  },
  {
    path: '/dashboard/financial-analysis',
    exact: true,
    name: 'Phân tích tài chính',
    function: 'DASHBOARD_FINANCIAL_ANALYSIS_VIEW',
    component: () => <FinancialDashboardPage mode='analysis' />,
  },
  {
    path: '/dashboard/payables',
    exact: true,
    name: 'Mua hàng & công nợ phải trả',
    function: 'DASHBOARD_PAYABLE_VIEW',
    component: () => <OperationalDashboardPage domain='payables' />,
  },
  {
    path: '/dashboard/sales-analysis',
    exact: true,
    name: 'Bán hàng & công nợ phải thu',
    function: 'DASHBOARD_SALES_VIEW',
    component: () => <OperationalDashboardPage domain='sales' />,
  },
  {
    path: '/dashboard/inventory-analysis',
    exact: true,
    name: 'Phân tích tồn kho',
    function: 'DASHBOARD_INVENTORY_ANALYSIS_VIEW',
    component: () => <OperationalDashboardPage domain='inventory' />,
  },
];

export default dashboardRoute;
